import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ValidationErrorMap, getValidationErrors, mapErrors } from 'icreate/common/validators';

@Component({
    selector: 'app-textarea-with-error',
    templateUrl: './textarea-with-error.component.html',
    styleUrls: ['./textarea-with-error.component.css'],
    standalone: false,
})
export class TextareaWithErrorComponent implements OnChanges {
    @Input() inputValue;
    @Input() disabledTextarea: boolean = false;
    @Input() legend: string;
    @Input() propertyName: string;
    @Input() validatorFunction;
    @Input() maxLength: number = 255;
    @Input() rows: number = 5;
    @Input() placeholder: string;
    @Input() hasCounter: boolean = false;

    @Output() onInputUpdated: EventEmitter<any> = new EventEmitter();

    isFocus: boolean = false;
    validationErrors: ValidationErrorMap = {};

    constructor(private translateService: TranslateService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.inputValue) {
            if (!changes.inputValue?.isFirstChange()) {
                this.checkInputErrors();
            }
        }
        if (changes.propertyName) {
            if (!changes.propertyName?.isFirstChange()) {
                this.checkInputErrors();
            }
        }
    }

    hasErrorString() {
        return this.propertyName in this.validationErrors;
    }

    getErrorString() {
        if (this.propertyName in this.validationErrors) {
            const err = this.validationErrors[this.propertyName];
            return this.translateService.instant(err.errors[0], err.params);
        }
        return;
    }

    inputFocus() {
        this.isFocus = true;
    }

    inputBlur() {
        this.isFocus = false;
        this.checkInputErrors();
    }

    checkInputErrors() {
        const object = {};
        object[this.propertyName] = this.inputValue;
        const errors = this.validatorFunction ? getValidationErrors(this.validatorFunction, object) : null;

        if (errors) {
            this.validationErrors = mapErrors(errors);
        }

        this.onInputUpdated.emit(this.inputValue);
    }
}
